
    import Vue from 'vue';
    import { mapGetters } from 'vuex';
    import { search } from '@/util/location';
    import { isSafari } from '@/util/browser';
    import { AppLoading, AppLoaded, AppInit, AppInited } from '@/util/metrics';
    import AppLayout from '@/components/Layout/AppLayout.vue';
    import AppTheme from '@/components/Layout/AppTheme.vue';
    import AppHeader from '@/components/Layout/AppHeader.vue';
    import AppFooter from '@/components/Layout/AppFooter.vue';
    import userHelper from '@/store/modules/user/helper';
    import signupHelper from '@/store/modules/signup/helper';
    import navigationHelper from '@/store/modules/navigation/helper';
    import ModalPresenter from '@/components/ModalPresenter.vue';
    import AsDynamicField from '@/components/AsDynamicField.vue';
    import NotFound from "./views/NotFound.vue";
    import { StaticPagesEnum } from '@/util/signup';
    import { logger } from '@/util/logger';

    export default Vue.extend({
	    name: 'App',
	    components: {
            AppLayout,
    		AppHeader,
	    	AppFooter,
		    AppTheme,
            ModalPresenter,
            NotFound,
		    ErrorPage: () => import(/* webpackChunkName: "systempages" */ './views/Error.vue'),
	    },
	    data(): { contentSize?: number, modalOpen: boolean, errored?: any, blur: boolean, loading: boolean, allowedSignupMessage?: string } {
		    return {
			    contentSize: undefined,
			    modalOpen: false,
			    errored: null,
			    blur: false,
			    loading: true,
			    allowedSignupMessage: undefined,
		    };
	    },
	    computed: {
            safari() { return isSafari as boolean; },
	    },
        watch: {
            modalOpen: function (newVal) {
            if (newVal == false) {
                setTimeout(function () {
                        if (document.activeElement == document.body) {
                            (document.querySelector('.burger-menu button') as HTMLElement).focus();
                        }
                    }, 350);
                }                
            },
        },
	    beforeMount() {
		    AppInit();
		    this.$store
			    .dispatch('init')
			    .catch((x: Error) => {
				    if (x.message.startsWith('Sorry we are unable')) {
					    this.allowedSignupMessage = x.message;
				    } else {
					    this.errored = x;
					    logger.critical(x);
				    }
			    })
			    .finally(() => {
				    this.loading = false;
                    AppInited();
			    });
		    if (isSafari) {
			    document.body.classList.add('safari');
		    }
	    },
        mounted() {
            AppLoaded();
        },
        created() {
            this.$router.beforeEach((to, from, next) => {
                document.body.setAttribute("tabindex", "-1");
                document.body.focus();
                document.body.removeAttribute("tabindex");
                next();
            });
            this.$router.afterEach((to, from) => {
            });
        },
    });
